"use client";
import React, { useState } from "react";
import "./CardComponent.css";

import SearchIcon from "@mui/icons-material/Search";
import { IconButton, TextField, InputAdornment } from "@mui/material";
import FlipCard from "@/components/FlipCard/FlipCard";
const CardComponent = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const cardData = [
    {
      id: "1",
      title: "What is AlfaMal?",
      description:
        "AlfaMall is a complete online shopping solution that enables Bank Alfalah and other bank’s customers to securely pay for their products of choice at the best prices and with high quality of services.",
    },
    {
      id: "2",
      title: "Payments methods can be used on AlfaMall?",
      description:
        "Bank Alfalah customers can use their accounts, wallets, credit cards or orbit points to make payments on AlfaMall to buy products online. Other bank’s customer can also pay via credit and debit card.",
    },
    {
      id: "3",
      title: "What are the charges for buying products on installments?",
      description:
        "AlfaMall provides Bank Alfalah customers with the facility to buy products on installments with 0% markup. BNPL (Buy Now Pay Later) will only be applicable if payment mode is selected as Bank Alfalah Credit Card.",
    },
    {
      id: "4",
      title:
        "Why are the installment prices high when it is considered as 0% markup?",
      description:
        'AlfaMalls 0% markup feature is a competitive segment of e-Commerce BNPL shout in the market. Customers have to pay once in the entire order cycle to book their product for up to 36 months of installments. The cost of installment is added to the price so customers don’t have to pay any markup. In case customers find high prices for the same product by different merchants, they can write their queries to <a href="https://alfamall.com/" target="_blank">www.alfamall.com</a> under the ‘Help’ section',
    },
    {
      id: "5",
      title: "How can I cancel my order?",
      description:
        'Customers can request to cancel their order within 24 hours of order placement by requesting cancellation of order via the bank’s helpline or ‘How may I help feature’ on <a href="https://alfamall.com/" target="_blank">www.alfamall.com</a>',
    },
    {
      id: "6",
      title: " How can I track my order?",
      description:
        "Customers can track an order by clicking on AlfaMall > My Account > My Orders.Customers will also get notifications on AlfaMall once the merchant updates the order status.",
    },
    // {
    //   id: "7",
    //   title: "How do I place an order on AlfaMall?",
    //   description:
    //     "Placing an order on AlfaMall is really simple and easy.Two options are available. Online Journey (5-7 working delivery TAT) and Self Pick up Feature (Instant delivery)Please follow these steps",
    // },
    {
      id: "8",
      title: " What do I do if there is a delay in order confirmation?",
      description:
        'You can contact the BAFL Call Center at 111-225-111 for more information (query) or register a complaint/query from <a href="https://alfamall.com/" target="_blank">www.alfamall.com</a>. Customers can contact the affiliated merchant to check if an order has been received. However, the product delivery TAT is 5 to 7 working days.',
    },
    {
      id: "9",
      title: " My order has been shipped. How quickly will I get my order?",
      description:
        "Products are usually delivered within 5 to 7 working days. In cases where the item delivery takes a longer delivery time, it will already be mentioned in the respective product description. Users are also requested to connect with AlfaMall affiliated merchant’s contact number",
    },
    {
      id: "10",
      title: "My order has been shipped but is delayed. What should I do?",
      description:
        "AlfaMall regrets any delayed delivery of user order(s). Users can follow the order progress by entering their tracking number on the courier’s tracking portal. If the status has not changed in a while, users are requested to connect with the AlfaMall affiliated merchants contact number.",
    },
    {
      id: "11",
      title: "Do I need an account to shop on AlfaMall?",
      description:
        "You will need an ‘Alfa’ or ‘Internet Banking / IB’ account to log in to AlfaMall. Guest users / other bank customers can access AlfaMall using web browsers",
    },
    {
      id: "12",
      title:
        "My payment was processed successfully but I didnot get any order confirmation. What should I do?",
      description:
        "Customer can track an order by clicking on AlfaMall > My Account > My Orders. If there are no order details, the customer will automatically get a refund within 5-7 working days.",
    },
    {
      id: "13",
      title: "I havenot received the invoice for my order.",
      description:
        "Complete order details are sent to the customer instantly as soon as an order is received on their registered email address. For further queries or complaints, contact your merchant along with the Order ID.",
    },
    {
      id: "14",
      title: "What are the shipping charges?",
      description:
        "Shipping rate calculated is based on the weight of the products, the origin from where the item is picked from and the destination to where it is delivered. The total shipping fee charged will be clearly indicated for each product individually at the main product page and the total shipping fee for the cart will be displayed at the checkout page",
    },
    {
      id: "15",
      title: "Why are my items shipped separately?",
      description:
        "Products ordered from different Merchants (Sellers) are often shipped separately as per delivery period mentioned to make sure that there is no delay in fulfillment of your order if one order will take longer than others.",
    },
    {
      id: "16",
      title: "Are all products new and original?",
      description:
        "Yes, AlfaMall is committed through its Merchant (Seller) to offering its users 100% genuine and original products. AlfaMall is a payment facilitator only to process payment and doesn’t guarantee any feature or warranty of product.  AlfaMall also takes all necessary actions to ensure this: any Merchant (Seller) found to be providing non-genuine product(s) is immediately delisted with the necessary action – additionally users are requested to rate products, which is essentially meant to value Merchant (Seller) quality of service. However, it does not mean that AlfaMall guarantee the product or services of Merchant, or for quality. Quantity, specification of the products offers and disclaim any liability, obligations whatsoever in nature in this regard, so customer needed to read guidelines carefully",
    },
    {
      id: "17",
      title: " Where should I go for my warranty claim?",
      description:
        "Please refer to the manufacturer (or service center) details on the warranty card included with the product (if applicable). If there is no warranty card, user is advised to check the user manual, product packaging. Customer will have to visit Brand’s warranty claim centre to claim warranty. Bank Alfalah doesn’t cater any warranty claim from any Brand and not responsible for any loss. However, customer may contact affiliated merchant (on the shared contact number) for warranty claim support.",
    },

    {
      id: "18",
      title: " I lost my warranty card. How can I claim warranty?",
      description:
        "Warranty card is mandatory to claim at Brand’s service center. Customer may seek merchant support to register claim at any authorized service center for the respective brand/product. Customer is requested to verify e-warranty of their products before launching query/complaint.",
    },
    {
      id: 20,
      title: "How do I pay on AlfaMall?",
      description:
        "User can pay on AlfaMall using their BAFL bank account, Orbit points, Debit or Credit Cards and Wallet Account. Once user is logged in to AlfaMall (via Web or App), these options will be made available to user via the Payment Gateway. Please note that you have to be a Bank Alfalah Customer (IB/Alfa sign in) to enter login details. Other bank customers may complete the journey as a Guest user in AlfaMall.",
    },
    {
      id: 19,
      title: "Do you offer Cash on Delivery?",
      description:
        "No. AlfaMall does not offer Cash on Delivery at this point in time however this service may be available very soon on AlfaMall.",
    },
    {
      id: 20,
      title: "What are the steps to return a product?",
      description:
        "Easy Return and Refund feature is available at AlfaMall. However change of mind is not applicable in case of return or refund. Customer will have to contact merchant for possible complaint whereas merchant will guide customer about the return process. In case if the query is still unattended, customer can register to post a query/complaint on www.alfamall.com under ‘Help’ section.",
    },
    {
      id: 21,
      title:
        "I found the package open and the product seal broken on delivery. What should I do?",
      description:
        "Customer shouldn’t accept opened or broken seal packaging. In case if it is accepted, customer should contact merchant to lodge a claim so a new/fresh parcel is dispatched to customer. The User Protection Process covers users who are unable to successfully resolve their complaint with the Merchant or are not satisfied with the resolution provided by the Merchant. User can file a complaint within 48 hours from the date of delivery of the product. Any damage or loss to the product 48 hours after delivery will not be covered under this program and will completely be the User’s responsibility.",
    },
    {
      id: 22,
      title: "My parcel has been reported missing. What now?",
      description:
        "Please connect with the merchant about the inquiry status of an order. Customer can also track updated status of his order by accessing ‘My order’ section of AlfaMall. Customer can also submit a request of ‘product not received’ under complaint section of www.alfamall.com.",
    },
    {
      id: 23,
      title: "How do I cancel my order?",
      description:
        'Please note that "Cancellation" is subject to Merchant Approval (since the order may already be in process to be delivered). Change of mind is not accepted. Furthermore, please note shipment charges shall not be refunded in the case of cancellation (if product is in transit). Alternatively, user is advised to please register their queries on www.alfamall.com or contact the Call Center at 111-225-111 to request for cancellation within 24 hours. If the user’s order is already on its way or if user has already received the order, they may be able to return the product if it is simultaneously posted as a cancelled product.',
    },
    {
      id: 24,
      title: "Does AlfaMall deliver all over Pakistan?",
      description:
        "Yes we deliver all over Pakistan besides ‘no-go defined areas as per proximity’ (this is subject to product description – if it is defined as restricted delivery).",
    },
    {
      id: 25,
      title: "How can I sign-up as a customer on AlfaMall?",
      description:
        "User needs to be registered on ‘ALFA’ or as an ‘Internet Banking (IB)’ customer. For more information on ‘Alfa’ and how to register, visit https://www.bankalfalah.com/personal-banking/self-service-banking/alfa/",
    },
    {
      id: 26,
      title: "How can I change the password of my AlfaMall account?",
      description:
        "The User Name & Password for AlfaMall are the same as your Alfa App/ IB credentials. To change the password, please follow the ‘Change Password’ process of ‘Alfa/IB’.",
    },
    {
      id: 27,
      title: "How can I add a new delivery address to my account?",
      description:
        'Log in to the User Account and click on “Your Account” Icon. Now click on “Manage My Account” in the drop down. User will be directed to their account where they will find "Address Book". Click on the “Add a New Address” button, enter the details of the new address and click on “Save this Address”. User can also add another address during the ‘Check Out’ process. Press the ‘Add New Address’ button on the ‘Delivery’ screen to add an address.',
    },
    {
      id: 28,
      title: "Can I add multiple email addresses to login to my account?",
      description:
        "To make sure that your account is always secure, multiple email addresses cannot be added.",
    },
    {
      id: 29,
      title: "Why do I need to provide my email address to sign up?",
      description:
        "Your email address helps us provide timely information to you about your order.",
    },
    {
      id: 30,
      title:
        "Can I use some other bank credit card for Installment transactions?",
      description:
        "No, Installment offer is valid for Bank Alfalah Credit Cards Only.",
    },
    {
      id: 31,
      title: "How many days will it take to deliver the product?",
      description: "5-7 business days.",
    },
    {
      id: 32,
      title: "How many days will it take to deliver the product?",
      description: "5-7 business days.",
    },
  ];
  const filteredCards = cardData.filter(
    (card) =>
      card.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      card.description.toLowerCase().includes(searchQuery.toLowerCase())
  );
  return (
    <div className="Homepage m-static-pages marginBottom60">
      <div className="row">
        <div className="col">
          <TextField
            id="searchInput"
            className="search-input"
            placeholder="Search entire store here..."
            variant="outlined"
            fullWidth
            value={searchQuery}
            sx={{ backgroundColor: "white" }}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>
      <div className="card-list">
        {filteredCards.length > 0 ? (
          filteredCards.map((card, index) => (
            <FlipCard
              key={index}
              title={card.title}
              description={card.description}
            />
          ))
        ) : (
          <p>No results found for "{searchQuery}".</p>
        )}
      </div>
    </div>
  );
};
export default CardComponent;
